import { FC } from "react";
import { ValueContainerProps } from "react-select";

import classNames from "classnames";

import { createComponentStyleHook } from "../../../../tokens";
import { OptionItem } from "../../OptionItem";

import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";

const useResolvedDropdownValueContainerStyles = createComponentStyleHook<ValueContainerProps<OptionItem | null>>({
  legacyStyles,
  tokenStyles,
  componentTokens: "dropdown_value_container",
});

/**
 * The select value container area.
 */
export const ValueContainer: FC<ValueContainerProps<OptionItem | null>> = (props) => {
  const { children, innerProps, selectProps } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedDropdownValueContainerStyles(props);

  const valueContainerClassName = classNames(styles.ValueContainer, "value-container", { opened: selectProps.menuIsOpen });

  return (
    <StyleModeBoundary mode={mode}>
      <div {...innerProps} className={valueContainerClassName}>
        {children}
      </div>
    </StyleModeBoundary>
  );
};
